import cx from 'classnames';
import { useEffect, useState } from 'react';
import { Collapse } from 'react-bootstrap';
import { usePrevious } from 'react-use';
import ArrowDownIcon from '../../components/icons/ArrowDownIcon';
import { CloseIcon } from '../../components/icons/CloseIcon';
import { dispatcher } from '../../helpers/projectHelper';
import { myprojectsActions } from '../../redux/slicers/my-projects/myProjectsSlicer';
import { Portal } from '../Portal';
import { useDownloadFileContext } from './DownloadFileContext';
import { DownloadsList } from './DownloadsList';
import styles from './SnackbarDownloadFileUI.module.scss';

export const SnackbarDownloadFileUI = (props) => {
  const { close, downloads, uploads, ids, isOpen, uploadIds } = useDownloadFileContext();
  const prevIds = usePrevious(ids);
  const prevUploadIds = usePrevious(ids);
  const [expanded, setExpanded] = useState(false);
  const [uploadsExpanded, setUploadsExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleUploadsExpandClick = () => {
    setUploadsExpanded(!uploadsExpanded);
  };

  useEffect(() => {
    if (prevIds?.length === 0 && ids.length !== 0) {
      setExpanded(true);
    }
  }, [ids]);

  useEffect(() => {
    if (prevUploadIds?.length === 0 && uploadIds.length !== 0) {
      setUploadsExpanded(true);
    }
  }, [uploadIds]);

  const downloadSections = Object.values(downloads);
  let totalFiles = 0;
  let downloadedFilesCount = 0;
  downloadSections.forEach((section) => {
    totalFiles += section.items.length;

    section.items.forEach((item) => {
      if (item.fileSizeBytes === item.downloadedBytes) {
        downloadedFilesCount += 1;
      }
    });
  });

  const uploadSections = Object.values(uploads);
  let totalUploadFiles = 0;
  let uploadedFilesCount = 0;
  uploadSections.forEach((section) => {
    totalUploadFiles += section.items.length;

    section.items.forEach((item) => {
      if (item.fileSizeBytes === item.downloadedBytes) {
        uploadedFilesCount += 1;
      }
    });
  });

  const downloadFinished = totalFiles > 0 && totalFiles === downloadedFilesCount;
  const uploadFinished = totalUploadFiles > 0 && totalUploadFiles === uploadedFilesCount;

  useEffect(() => {
    const finishedAndNoUploads = downloadFinished && totalUploadFiles === 0;
    const allFinished = downloadFinished && uploadFinished;
    if (finishedAndNoUploads || allFinished) {
      close();
    } else if (downloadFinished) {
      close({ section: 'downloads' })
    }
  }, [downloadFinished]);

  useEffect(() => {
    const finishedAndNoDownloads = uploadFinished && totalFiles === 0;
    const allFinished = uploadFinished && downloadFinished;
    if (finishedAndNoDownloads || allFinished) {
      close();
    } else if (uploadFinished) {
      close({ section: 'uplloads' })
    }
    
    uploadFinished && dispatcher(myprojectsActions.setIsItemUploading(false));
  }, [uploadFinished]);



  // TODO: work on hiding/showing donwload progress animation
  return (
    <Portal>
      <div className={cx(styles.root, isOpen && styles.open)}>
        {totalUploadFiles > 0 && (
          <div className={cx(styles.card, 'mb-3')}>
            <div className={styles.actionRoot}>
              <div className={styles.typography}>
                Uploads
                <span className={styles.downloadedCount}>
                  ({uploadedFilesCount}/{totalUploadFiles})
                </span>
              </div>

              <div className={styles.icons}>
                <button
                  onClick={handleUploadsExpandClick}
                  className={cx(styles.iconButton, {
                    [styles.expandOpen]: uploadsExpanded,
                  })}>
                  <ArrowDownIcon />
                </button>
                <button className={styles.iconButton} onClick={() => close()}>
                  <CloseIcon style={{ width: 14, marginBottom: 1 }} />
                </button>
              </div>
            </div>
            <Collapse in={uploadsExpanded} timeout={200} unmountOnExit>
              <div className={styles.collapse}>
                {uploadSections.map((section, idx) => {
                  return <DownloadsList items={section.items} key={idx} />
                })}
              </div>
            </Collapse>
          </div>
        )}

        {totalFiles > 0 && (
          <div className={styles.card}>
            <div className={styles.actionRoot}>
              <div className={styles.typography}>
                Downloads
                {/* {downloadFinished && <RiCheckLine fontSize={18} className={styles.successIcon} />}
                {!downloadFinished && (
                  <span className={styles.downloadedCount}>
                    ({downloadedFilesCount}/{totalFiles})
                  </span>
                )} */}
                <span className={styles.downloadedCount}>
                  ({downloadedFilesCount}/{totalFiles})
                </span>
              </div>

              <div className={styles.icons}>
                <button
                  onClick={handleExpandClick}
                  className={cx(styles.iconButton, {
                    [styles.expandOpen]: expanded,
                  })}>
                  <ArrowDownIcon />
                </button>
                <button className={styles.iconButton} onClick={() => close()}>
                  <CloseIcon style={{ width: 14, marginBottom: 1 }} />
                </button>
              </div>
            </div>
            <Collapse in={expanded} timeout={200} unmountOnExit>
              <div className={styles.collapse}>
                {downloadSections.map((section, idx) => (
                  <DownloadsList items={section.items} key={idx} />
                ))}
              </div>
            </Collapse>
          </div>
        )}
      </div>
    </Portal>
  );
};
